import React from "react";

export default function AlertBox({ type = "error", message, onClose }) {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
            }}
        >
            <div
                style={{
                    background: "#fff",
                    padding: "25px 30px",
                    borderRadius: "8px",
                    minWidth: "320px",
                    maxWidth: "420px",
                    textAlign: "center",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                    border:
                        type === "error"
                            ? "2px solid #d9534f"
                            : "2px solid #5cb85c"
                }}
            >
                {/* title */}
                <h4
                    style={{
                        marginTop: 0,
                        marginBottom: "15px",
                        color: type === "error" ? "#d9534f" : "#5cb85c"
                    }}
                >
                    {type === "error" ? "Error" : "Success"}
                </h4>

                {/* message */}
                <p style={{ marginBottom: "25px", fontSize: "15px" }}>
                    {message}
                </p>

                <button
                    className="btn btn-primary"
                    onClick={onClose}
                    style={{ width: "100px" }}
                >
                    OK
                </button>
            </div>
        </div>
    );
}
